/**
 * FULLER ARCHIVE — Mega Menu (v1.1.41)
 * Opens on hover over the "Catalog" nav link.
 * Closes on mouse-leave or Escape key.
 */
(() => {
  const TRIGGER_TEXTS = ['catalog', 'shop', 'collection'];
  const OPEN_DELAY = 120;
  const CLOSE_DELAY = 200;

  const menu = document.getElementById('fa-mega-menu');
  if (!menu) return;

  let openTimer = null;
  let closeTimer = null;

  function open() {
    clearTimeout(closeTimer);
    openTimer = setTimeout(() => {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
    }, OPEN_DELAY);
  }

  function close() {
    clearTimeout(openTimer);
    closeTimer = setTimeout(() => {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
    }, CLOSE_DELAY);
  }

  // Find all desktop nav links
  function bindTriggers() {
    const navLinks = document.querySelectorAll(
      '.menu-list__link, .menu-list__list-item > a, [ref="menuitem"]'
    );

    navLinks.forEach(link => {
      const text = link.textContent.trim().toLowerCase();
      const isTrigger = TRIGGER_TEXTS.some(t => text.includes(t));

      if (isTrigger) {
        const li = link.closest('li') || link.parentElement;
        li.addEventListener('mouseenter', open);
        li.addEventListener('mouseleave', close);
        link.addEventListener('focus', open);
        link.addEventListener('blur', close);
      }
    });
  }

  // Keep menu open when hovering over it
  menu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
  menu.addEventListener('mouseleave', close);

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!menu.contains(e.target) && !e.target.closest('.menu-list__list-item')) {
      close();
    }
  });

  // Bind after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTriggers);
  } else {
    bindTriggers();
  }

  // Re-bind after any Shopify section updates
  document.addEventListener('shopify:section:load', bindTriggers);
})();
